import { apiGet } from '../api'

export const get_induction_report = (year, program_id) => {
  return apiGet({
    endpoint: `reports/program_update?${year ? `year=${year}` : ''}${
      program_id ? `&program_id=${program_id}` : ''
    }`
  })
}
